import { SET_LOADING } from './types';

export const setLoading = (payload) => {
	return {
		payload,
		type: SET_LOADING
	};
};
